const my_profile = {
  viewMyClubSeacretProfile: "ดูโปรไฟล์ ClubSeacret ของฉัน", // translated
  viewMoreDetails: "ดูรายละเอียดเพิ่มเติม", // translated
  verifiedEmail: "อีเมลที่ยืนยันแล้ว", // translated
  unverifiedEmail: "อีเมลที่ไม่ได้รับการยืนยัน", // translated
  pointsIn: "ชี้เข้า", // translated
  pointsOut: "ชี้ให้เห็น", // translated
  balance: "สมดุล", // translated
  pointsHistoryTable: "ตารางประวัติคะแนน", // translated
  topUp: "เติม", // translated
  createdFrom: "สร้างจาก", // translated
  createdTo: "สร้างถึง", // translated
  selectStatus: "เลือกสถานะ...", // translated
  searchByTitle: "ค้นหาตามชื่อเรื่อง...", // translated
  pushNotifications: "การควบคุมแบบ Push", // translated 
  pushNotificationsDescription: "รับการดูแลจากครั้งต่อไปสำหรับและที่สำคัญ", // translated 
  pushNotificationsNotSupported: "การควบคุมแบบ Push ระบบควบคุมในคืนนี้", // translated 
  pushNotificationsDeniedMessage: "คุณสมบัติที่ถูกปฏิเสธการควบคุมในการควบคุมในการควบคุมแบบ Push", // translated 
  pushNotificationsEnabled: "การแจ้งเตือนแบบ Push สำเร็จ", // translated 
  pushNotificationsDisabled: "หลังจากบันทึกแบบ Push สำเร็จ", // translated 
  userInformationMissing: "ข้อมูลผู้ใช้หายไป", // translated 
  failedToUpdatePushNotifications: "จะมีการอัพเดตการแจ้งเตือนแบบ Push", // translated 
  notificationPermissionDenied: "การร้องเรียนถูกปฏิเสธเหตุผลในการตัดสินใจ", // translated 
  notificationPermissionRequired: "คุณสมบัติการจับเวลาเพื่อแจ้งเตือนแบบ Push", // translated 
  notSupported: "การควบคุมการรับชม", // translated 
  permissionDenied: "การถูกปฏิเสธ", // translated 
  permissionNotRequested: "ขอให้การท", // translated 
  enabled: "หลังจากนั้น", // translated 
  disabled: "หล่อ", // translated 
};


export default my_profile;
